import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import About from "./components/About";
import Products from "./components/Products";
import Services from "./components/Services";
import Clients from "./components/Clients";
import Login from "./components/Login";
import Footer from "./components/Footer";
import Signup from "./components/Signup";
import Inquiry from "./components/Inquiry";
import AdminPanel from "./components/AdminPanel";
import AuthProvider from './context/AuthContext'
import WebDevelopment from "./components/WebDevelopment";
import MobileAppDev from "./components/MobileAppDev";
import EcomDev from "./components/EcomDev";
import SchoolManagementSystems from "./components/SchoolManagementSystems";
import HospitalManagementSystems from "./components/HospitalManagementSystems";
import Integrations from "./components/Integrations";
import DigitalMarketing from "./components/DigitalMarketing";
import Kidsmatter from "./components/Kidsmatter";
import SchoolApp from "./components/SchoolApp";
import Social from "./components/Social";
import ChatBot from "./components/ChatBot";
import OurEcom from "./components/OurEcom";
import Background from "./components/Background"; 
import AnimatedBackground from "./components/AnimatedBackground"; // Import your component

import Contact from "./components/Contact";



import Logo from "./components/Fusionxe";
function App() {
  return (
    <div className="App">
      <Navbar />
      {/* <AnimatedBackground  /> */}
     < Background />
    <AuthProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/Products" element={<Products />} />
          <Route path="/Services" element={<Services />} />
          <Route path="/Clients" element={<Clients />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Signup />} />
          <Route path="/inquiry" element={<Inquiry />} />
          <Route path="/webdev" element={<WebDevelopment />} />
          <Route path="/mobileapp" element={<MobileAppDev />} />
          <Route path="/ecommerce" element={<EcomDev />} />
          <Route path="/school-systems" element={<SchoolManagementSystems/>} />
          <Route path="/hospital" element={<HospitalManagementSystems/>} />
          <Route path="/intergrations" element={<Integrations/>} />

          <Route path="/admpnal" element={<AdminPanel/>} />
          <Route path="/digital-marketing" element={<DigitalMarketing/>} />
          <Route path="/kidsmatter" element={<Kidsmatter/>} />
          <Route path="/schlapp" element={<SchoolApp/>} />
          <Route path="/social" element={<Social/>} />
          <Route path="/ChatBot" element={<ChatBot/>} />
          <Route path="/OurEcom" element={<OurEcom/>} />
          <Route path="/logo" element={<Logo/>} />
          <Route path="/contact" element={<Contact />} />



          






        </Routes>
        </AuthProvider>
        <Footer />
      
    </div>
  );
}

export default App;
